import React, { useState, useEffect } from 'react'

import DateRangeIcon from '@mui/icons-material/DateRange'
import {
  Button,
  Col,
  Input,
  Row,
  SelectForm,
  Span,
  TimePicker
} from 'components'
import { useToggle } from 'hooks'
import moment from 'moment'
import { COLORS, SPACING } from 'utils'

import { IPeriocidadeComponent } from '../Diario/Diario'
import MultipleDaySelect from './components/MultipleDaySelect'

const Mensal: React.FC<IPeriocidadeComponent> = ({
  control,
  errors,
  periodicidade,
  listOptions,
  setValue,
  clearErrors,
  setHasErrorJob,
  jobRecorrenciasList,
  jobNuDiasRecorrencia,
  isConsult
}) => {
  // LISTA HORARIO DO COMPONENTE
  const [listMensal, setListMensal] = useState([
    {
      hrRecorrencia: '',
      id: 0
    }
  ])
  const [selectedDays, setSelectedDays] = useState([])
  const [showMultipleDaySelect, toggleShowMultipleDaySelect] = useToggle()
  const [errorsJobs, setErrorsJobs] = useState({ horarioError: null })

  // ENVIO DOS DADOS DO COMPONENTE PARA MODAL

  // NOVA LINHA DE HORARIO
  const handleNewItem = () => {
    setListMensal([
      ...listMensal,
      {
        hrRecorrencia: '',
        id: listMensal[listMensal.length - 1].id + 1
      }
    ])
  }

  // UPDATE DO HORARIO NA LISTA HORARIO
  const handleTimePicker = (time, index) => {
    if (time) {
      const cpyArr = listMensal.slice()
      cpyArr[index].hrRecorrencia = time
      setListMensal(cpyArr)
      setValue('mensal', cpyArr)
      setValue('horario', time)
      clearErrors()
    }
  }

  /*
  // UPDATE DO DATA NA LISTA HORARIO
  const handleDatePicker = (date, index) => {
    const cpyArr = listMensal.slice()
    setListMensal(cpyArr)
    setValue('mensal', cpyArr)
  }

  // UPDATE NA LISTA DE DATAS
  const handleMultiDatePicker = (date) => {
    if (date) {
      setSelectedDays((selectedDays) => [
        ...selectedDays,
        moment(date).format('DD').toString()
      ])
    }
  }
  */

  // DELETAR HORARIO ADICIONADO
  const handleDelete = (id: number) => {
    const cpyArr = listMensal.slice()
    setListMensal(cpyArr.filter((hr) => hr.id !== id))
    setValue(
      'mensal',
      cpyArr.filter((hr) => hr.id !== id)
    )
  }

  const handleClean = () => {
    setListMensal([{ hrRecorrencia: null, id: 0 }])
    setValue('mensal', [])
    setValue('mensalString', '')
    setSelectedDays([])
  }

  useEffect(() => {
    if (jobRecorrenciasList.length == 0) {
      setListMensal([
        {
          hrRecorrencia: '',
          id: 0
        }
      ])
    } else {
      setListMensal(jobRecorrenciasList)
      setValue('mensal', jobRecorrenciasList)
    }

    const nuDiasRecorrencia =
      jobNuDiasRecorrencia !== '' ? jobNuDiasRecorrencia?.split(',') : []

    setSelectedDays(nuDiasRecorrencia)
  }, [])

  useEffect(() => {
    setValue('mensalString', selectedDays.toString())
    clearErrors()
  }, [selectedDays])

  useEffect(() => {
    const tempVar = listMensal.filter(
      (item) => item.hrRecorrencia !== '' && item.hrRecorrencia !== null
    )

    if (tempVar.length > 0) {
      setErrorsJobs((old) => ({
        ...old,
        horarioError: null
      }))
      setHasErrorJob((old) => ({
        ...old,
        horarioError: false
      }))
    } else {
      setErrorsJobs((old) => ({
        ...old,
        horarioError: {
          message: 'Ao menos um horário deve ser informado'
        }
      }))
      setHasErrorJob((old) => ({
        ...old,
        horarioError: true
      }))
    }
  }, [listMensal])

  return (
    <>
      <Col>
        <Row justifyContent="start">
          <Col>
            <Row justifyContent="start">
              <SelectForm
                defaultValue={periodicidade}
                control={control}
                listOptions={listOptions}
                label="Tipo"
                width="160px"
                formValue="tipo"
                marginTop={SPACING.spacing15}
                marginRight={SPACING.spacing20}
                disabled={isConsult}
              />
              <Row onClick={!isConsult ? toggleShowMultipleDaySelect : null}>
                <Input
                  errors={errors}
                  control={control}
                  label="Dias selecionados"
                  formValue="mensalString"
                  marginTop={SPACING.spacing15}
                  width="350px"
                  disabled
                />
                <Col>
                  <Span
                    marginTop={SPACING.spacing20}
                    text="D"
                    color={COLORS.white}
                  />
                  <DateRangeIcon
                    cursor="pointer"
                    //onClick={toggleShowMultipleDaySelect}
                  />
                </Col>
              </Row>
            </Row>
          </Col>
          <Col marginLeft={SPACING.spacing20} marginTop={SPACING.spacing10}>
            {listMensal.map((diario, index) => (
              <Col key={index} marginBottom={SPACING.spacing10}>
                <Row alignItems="center" justifyContent="start">
                  <TimePicker
                    marginRight={SPACING.spacing20}
                    marginTop={SPACING.spacing5}
                    customError={errorsJobs.horarioError}
                    label="Horário"
                    value={
                      diario.hrRecorrencia
                        ? moment(diario.hrRecorrencia).toDate()
                        : null
                    }
                    onChange={(data) => handleTimePicker(data, index)}
                    allowTyping={true}
                    disabled={isConsult}
                  />

                  {listMensal.length - 1 === index ? (
                    <Button
                      text="+"
                      onClick={handleNewItem}
                      disabled={isConsult}
                    />
                  ) : (
                    <Button
                      text="-"
                      onClick={() => handleDelete(diario.id)}
                      disabled={isConsult}
                    />
                  )}
                </Row>
              </Col>
            ))}
          </Col>
        </Row>
        <Row alignItems="center" justifyContent="end">
          <Button
            text="Limpar"
            onClick={handleClean}
            variantButton="text"
            disabled={isConsult}
          />
        </Row>
      </Col>
      <MultipleDaySelect
        setSelectedDays={setSelectedDays}
        selectedDays={selectedDays}
        showMultipleDaySelect={showMultipleDaySelect}
        toggleModal={toggleShowMultipleDaySelect}
      />
    </>
  )
}

export default Mensal
